import React, { useState } from 'react';

const tabs = [
  { id: 'roundtrip', label: 'Round Trip', icon: '🚌', img:'https://dapurpacu.id/wp-content/uploads/2022/12/innova-zenix-dp01.jpg' },
  { id: 'dropoff', label: 'Drop Off', icon: '📍',img:'https://jasapro.biz.id/uploads/Rental20240326-032139-Rental%20Mobil%20Drop%20Off%20Jakarta%20ke%20Bandung.webp'  },
  { id: 'antar-jemput-bandara', label: 'Antar Jemput Bandara', icon: '🚗' ,img:'https://jatengpos.co.id/wp-content/uploads/2022/10/rental-mobil-antar-jemput-bandara-jakarta.jpg' },
  { id: 'vacation', label: 'Vacation', icon: '🌴' ,img:'https://samudrafakta.com/wp-content/uploads/2023/12/images-2023-12-12T155813.008.jpeg' }
];

const TabContent = ({ id }) => {
  const content = {
    'roundtrip': "Di tengah kesibukan rutinitas harian Anda, layanan Pulang Pergi kami di Vavelle & Co Rental Mobil dirancang untuk memperlancar kebutuhan perjalanan Anda, menawarkan solusi yang mudah untuk perjalanan berangkat dan pulang. Baik Anda sedang mengurus keperluan sehari-hari, menghadiri rapat bisnis penting, atau mengurus tugas-tugas yang berhubungan dengan kantor, kami menyediakan transportasi yang andal dan nyaman sesuai dengan jadwal Anda. Temukan kemudahan dan kenyamanannya",
    'dropoff': "Bepergian untuk liburan, perjalanan bisnis, atau kunjungan kembali ke kampung halaman tidak pernah semudah atau sehemat ini. Selain perjalanan dalam kota, fitur Drop Off di Vavelle & Co Rental Mobil juga mencakup destinasi luar kota, termasuk Pulau Jawa, Pulau Sumatra, dan Bali. Baik Anda menjelajahi tempat baru, menghadiri komitmen kerja, atau sekadar pulang kampung, kami menyediakan solusi yang nyaman dan terjangkau untuk memenuhi kebutuhan Anda. Nikmati perjalanan yang nyaman dan bebas repot dengan Vavelle & Co Rental Mobil, mitra tepercaya Anda untuk setiap petualangan.",
    'antar-jemput-bandara': "Hindari kerumitan transportasi bandara dan rencanakan perjalanan Anda dengan tenang dengan memesan terlebih dahulu. Layanan transfer bandara kami memastikan perjalanan yang lancar dan nyaman, baik Anda bepergian untuk bisnis maupun liburan.",
    'vacation': "Kami berkomitmen untuk menemani Anda dalam petualangan Anda di Indonesia, menjelajahi berbagai daerah di negara ini melalui jalur darat. Layanan kami memastikan pengalaman yang hemat biaya, menyenangkan, dan berkesan, serta mendekatkan Anda dengan orang-orang yang Anda cintai dan teman-teman.",  };

  return (
    <div className="flex flex-col lg:flex-row items-center gap-8 bg-white text-lg text-black">
      <div className="lg:w-1/2 py-16 px-4 lg:px-8 flex items-center justify-center">
        <div>
          <h2 className="text-xl lg:text-2xl font-bold mb-4 text-center">{tabs.find(tab => tab.id === id).label}</h2>
          <p className="mb-4 text-center">{content[id]}</p>
          <a href="https://wa.me/6281398253186?text=Halo,%20saya%20tertarik%20untuk%20rental%20mobil" 
             className="inline-block px-6 py-3 bg-red-500 text-white rounded-full font-semibold shadow-lg hover:bg-red-700 transition duration-300">
            <span className="mr-2">Pesan Sekarang</span>
            <span role="img" aria-label="whatsapp">WhatsApp</span>
          </a>
        </div>
      </div>
      <div className="lg:w-1/2 flex items-center justify-center">
        <img 
          src={tabs.find(tab => tab.id === id).img} 
          alt={id} 
          className="w-full object-cover h-auto"
        />
      </div>
    </div>
  );
};

export default function TabSection() {
  const [activeTab, setActiveTab] = useState(tabs[2].id); // Starting with 'Antar Jemput Bandara' as active

  return (
    <section className="w-full">
      <div className="container mx-auto px-4 md:px-8">
        {/* Tab Navigation */}
        <div className="flex justify-center overflow-x-auto whitespace-nowrap space-x-2 mb-8 p-1 rounded-fullflex flex-col md:flex-row justify-center overflow-x-auto md:overflow-x-visible whitespace-nowrap md:whitespace-normal space-y-2 md:space-y-0 md:space-x-2 mb-8 p-1 ">
          {tabs.map(tab => (
            <button 
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition duration-300 ${activeTab === tab.id ? 'bg-red-600 text-white' : 'bg-white text-red-600 border-2 border-red-600 hover:bg-red-600 hover:text-white'}`}
            >
              <span className="mr-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>
        
        {/* Tab Content */}
        <div className="bg-white p-6 rounded-lg">
          {tabs.map(tab => (
            <div 
              key={tab.id}
              className={activeTab === tab.id ? 'block' : 'hidden'}
            >
              <TabContent id={tab.id} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}